<template>
    <div class="all-100 large-50 medium-50 small-100 tiny-100" id="playlist-item-template">
        <a href="#" @click="playAudio($event)" class="item" :class="isActive ? 'active' : ''">
            <div class="column-group" >
                <div class="all-20 medium-40 small-30 tiny-40">
                    <div class="playlist-item">
                        <img class="playlist-cover-art" alt="" :src="track.album.images[0].url">
                        <div class="overlay"></div>
                        <i class="fa fa-play-circle-o" aria-hidden="true"></i>
                        <i class="fa fa-pause-circle-o" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="all-70 medium-40 small-40 tiny-40 half-left-space">
                    <div class="track">{{track.name}}</div>
                    <div class="artist">{{getArtist}}</div>
                    <div class="album">{{track.album.name}}</div>
                    <audio ref="audioEl" class="audio" hidden></audio>
                </div>
            </div>
        </a>
    </div>  
</template>

<script>
export default {
    name: "TrackItem",
    props: {
        track: Object,
        selectedTrackId: String
    },
    data() {
        return {
            isActive: false
        }
    },
    methods: {
        playTrack() {
            this.$emit('onClickTrack', this.track.id);
            if(!this.$refs.audioEl.duration) this.$refs.audioEl.src = this.track.preview_url;

            this.$refs.audioEl.play();
            this.$refs.audioEl.addEventListener('ended', () => this.isActive = false);                   
            this.isActive = true;             
        },
        playAudio(e) {
            e.preventDefault();
            if(!this.$refs.audioEl.paused) {
                this.pauseTrack();
            } else {
                this.playTrack();
            }
        },
        pauseTrack() {
            this.isActive = false;
            this.$refs.audioEl.pause();
        },        
    },
    computed: {
        getArtist() {
            return this.track.artists.reduce(function(artists, a) {
                if (!artists || artists.length + a.name.length < 80) {
                    artists += (artists ? " & " : "") + a.name;
                }
                return artists;
            }, "");
        }
    },
    watch: {
        selectedTrackId: function (newValue) {
            if(newValue !== this.track.id) {
                this.pauseTrack();
            }
        }
    }
};
</script>
<style lang="scss">
.track {
    display: inline-block;
    width: 200px;
    img {
      width: 100%;
      height: 100%;
    }
}
</style>


